module.exports = __webpack_public_path__ + "img/bg-10.8c3eb472.jpg";